// progressPercent (0-100 | '') -> render-ready label for the header progress bar (C1, RN21).
//
// `progressPercent` is the ONLY field the bar reads. `statusProgress` (a text enum) never feeds
// it — R-20 forbids converting that enum to a number. '' (the value detailApi.js maps `null`
// to) means "not computable": no bar, no 0%, just the literal (S297).
export const progressLabel = (header) => {
  const source = header || {}
  const percent = source.progressPercent

  if (percent === '' || percent === null || percent === undefined) {
    return { computable: false }
  }

  const quantity = source.quantity || {}
  return {
    computable: true,
    percent,
    good: quantity.good,
    nominal: quantity.nominal
  }
}
